import React from 'react';
import * as S from "./style"
import { useAuth } from 'contexts/AuthContext';
import ThemeSelector from 'components/ProfileSection/ThemeSelector';
import ProfileBadge from "./ProfileBadge";

const ProfileSection: React.FC = () => {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <S.ProfileContainer>
      <ProfileBadge />
      <ThemeSelector />
    </S.ProfileContainer>
  );
};

export default ProfileSection;
